'use strict';

import $ from 'jquery';


/**
 * Manipulates front-end elements that indicate current state of cart
 * @class Cart
 */
class Cart {

  /**
   * Creates an instance of Cart.
   * @memberof Cart
   */
  constructor(){
    this.deadline = typeof document !== 'undefined' && document.querySelector('[data-cart-timer]') ? parseInt(document.querySelector('[data-cart-timer]').getAttribute('data-cart-timer'),10) : null;
    this.timerEls = document.querySelectorAll('.cart-timer');
    this.ajaxEndPoint = '/stage-ajax/cart';
    this.lang = $(document.body).data('stage-loc') || 'fi';
    this.$form = $('#campaign-code-form');
    this.$input = $('input[name="campaign-code"]');
    this.$codeActiveEl = $('.cart-page-body__campaign-code-container');
    this.$removeCodeEl = $('.js-remove-campaign-code');
    this.$codeTextEl = $('.cart-page-body__campaign-active-code');
    this.$errorEl = $('.cart-page-body__campaign-error');
  }

  /**
   * Access Cart API endpoint
   * @param {string} method - Request method [GET]
   * @param {string} action - Request action [update|add|remove|add-discount-code|remove-discount-code]
   * @param {number|int} amount - Amount of requested item
   * @param {number|int} catalogId - Item identifier
   * @param {string} discountCode - Discount code from user
   * @returns {object} Ajax response (Cart)
   * @todo Ajax error handling
   */
  cartApi(method = 'GET', action = 'update', amount = 0, catalogId = 0, discountCode = '') {
    const lang = this.lang;
    return $.ajax({
      url: `${this.ajaxEndPoint}/?action=${action}&amount=${amount}&catalog_id=${catalogId}&discount_code=${discountCode}&stage-language=${lang}`,
      method: method
    });
  }

  /**
   * Attach events for dom elements in Cart page
   * @memberof Cart
   */
  attachEvents(){
    const parent = this;

    // campaign-code input in cart page
    $(document).on('submit',this.$form,function(e){
      e.preventDefault();
      parent.$errorEl.html('');
      let cartRequest;

      if( parent.$input.val() ){
        cartRequest = parent.cartApi('GET','add-discount-code','','',parent.$input.val());
      }
      else {
        cartRequest = parent.cartApi('GET','remove-discount-code','','','');
      }

      if( cartRequest ){
        cartRequest
          .done(function(response, textStatus) {
            let discountCode, errorsMarkup;
            try {
              errorsMarkup = response.errors.common.join('<br/>') || '';
              discountCode = response.cart.cart.discount_code || '';
              // ajax ok, but error found in response
              if( errorsMarkup ){
                parent.toggleForm( true );
                parent.$errorEl.html( errorsMarkup );
              }
              // discount code OK
              else {
                parent.toggleForm( false );
                parent.$codeTextEl.text( discountCode );
                window.location.reload(false); // reload page to show discounted prices
              }
            }
            catch(e){
            // something is wrong in response object
              parent.toggleForm(true);
              parent.$errorEl.html('Error occurred. Please try again later.');
            }
          }).fail(function(error, textStatus) {
          // ajax failed
            parent.toggleForm(true);
            parent.$errorEl.html(textStatus + ': ' + error.status );
          });
      }
    });

    // Remove discount code
    this.$removeCodeEl.on('click',function(){
      const request = parent.cartApi('GET','remove-discount-code','','','');
      request.done(function(response, textStatus){
        window.location.reload(false);
      });
    });

  } // attachEvents()

  /**
   * Toggle Campaign-code form visibility;
   * @param {boolean} [state] - If omitted, toggles form visibility. TRUE shows form and vice versa.
   * @memberof Cart
   */
  toggleForm(state){
    if( typeof state === 'undefined' ) state = this.$form.is(':visible') ? false : true ;
    this.$form.toggle(state);
    this.$codeActiveEl.toggle(!state);
  }

  /**
   * Set up timers for cart elements in UI
   * @param {*} deadline - timestamp to compare current time to
   */
  startTimer(deadline = this.deadline){
    if( !deadline ) return;
    const parent = this;

    // run every second and update cart time in UI
    var x = setInterval(function() {

      const now = new Date().getTime();
      const t = deadline - now;
      // const days = Math.floor(t / (1000 * 60 * 60 * 24));
      // const hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60));
      const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((t % (1000 * 60)) / 1000);
      if( seconds < 10 ) seconds = '0' + seconds; // add leading zero
      let str = `${minutes}:${seconds}`;
      const expired = t < 0 ? true : false;
      const expireClass = ' expired';

      if( expired ){
        clearInterval(x);
        str = '0:00';
      }
      for( let i = 0; i < parent.timerEls.length ; i++ ){
        const el = parent.timerEls[i];
        if( expired ) {
          const a = parent.__getClosest(el,'a');
          if( a ) a.className += expireClass;
        }
        el.innerHTML = str;
      }

    }, 1000);
  }

  /**
   * returns closest parent element that matches css selector
   * @private
   * @param {*} elem - start from this element
   * @param {*} selector - css selector to use
   * @returns {Object} - matching element if found, otherwise null
   * @memberof Cart
   */
  __getClosest(elem,selector){
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) { /* */ }
          return i > -1;
        };
    }

    // Get the closest matching element
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
      if ( elem.matches( selector ) ) return elem;
    }
    return null;
  }

  /**
   * init cart
   * @memberof Cart
   */
  init(){
    if( this.deadline ) this.startTimer();
    if( this.$form.length ) this.attachEvents();
  }
}

export default new Cart();
